import { createAggrApiInstance } from '@/utils/api/axiosInstance'
import { handleApiStatus } from '@/utils/api/handleAPI'

import * as aggr from '@/api-generator/aggr/index'

export interface StaffMemberSubtotal {
  staffMemberCount: number
}

const userMgmtStaffApi = createAggrApiInstance(aggr.UserMgmtStaffApi)

export const queryStaffMember = async (reqData: aggr.UserMgmtQueryStaffMemberRq) => {
  const res = await handleApiStatus(() => userMgmtStaffApi.staffQuerystaffmembers(reqData))
  return res
}

export const queryStaffMemberSubtotal = async (reqData: aggr.UserMgmtQueryStaffMemberSubtotalRq) => {
  const res = await handleApiStatus(() => userMgmtStaffApi.staffQuerystaffmembersubtotal(reqData))
  return res
}

export const transferStaffPermission = async (reqData: aggr.UserMgmtTransferStaffPermissionRq) => {
  const res = await handleApiStatus(() => userMgmtStaffApi.staffTransferstaffpermission(reqData))
  return res
}

export const deleteStaffMember = async (reqData: aggr.UserMgmtDeleteStaffAccountRq) => {
  const res = await handleApiStatus(() => userMgmtStaffApi.staffDeletestaffaccount(reqData))
  return res
}

export const changeStaffRole = async (reqData: aggr.UserMgmtChangeStaffRoleRq) => {
  const res = await handleApiStatus(() => userMgmtStaffApi.staffChangestaffrole(reqData))
  return res
}

export const queryStaffRegistrationLink = async (reqData: aggr.UserMgmtGenerateStaffRegistrationLinkRq) => {
  const res = await handleApiStatus(() => userMgmtStaffApi.staffQuerystaffregistrationlink(reqData))
  return res
}

export const generateStaffRegistrationLink = async (reqData: aggr.UserMgmtGenerateStaffRegistrationLinkRq) => {
  const res = await handleApiStatus(() => userMgmtStaffApi.staffGeneratestaffregistrationlink(reqData))
  return res
}

export const deleteStaffRegistrationLink = async (reqData: aggr.UserMgmtGenerateStaffRegistrationLinkRq) => {
  const res = await handleApiStatus(() => userMgmtStaffApi.staffDeletestaffregistrationlink(reqData))
  return res
}

export const sendStaffRegistrationInvitation = async (reqData: aggr.UserMgmtSendStaffRegistrationInvitationRq) => {
  const res = await handleApiStatus(() => userMgmtStaffApi.staffSendstaffregistrationinvitation(reqData))
  return res
}

export const assignCompanyContactToStaff = async (reqData: aggr.UserMgmtAssignCompanyContactToStaffRq) => {
  const res = await handleApiStatus(() => userMgmtStaffApi.staffAssigncompanycontacttostaff(reqData))
  return res
}

export const deleteCompanyContactAssignment = async (reqData: aggr.UserMgmtDeleteCompanyContactByStaff) => {
  const res = await handleApiStatus(() => userMgmtStaffApi.staffDeletecompanycontactbystaff(reqData))
  return res
}

export const getPendingStaffInvitationCount = async () => {
  const res = await handleApiStatus(() => userMgmtStaffApi.staffGetcurrentuserpendingstaffinvitationcount())
  return res
}

export const resendAllPendingStaffInvitations = async () => {
  const res = await handleApiStatus(() => userMgmtStaffApi.staffResendcurrentuserallpendingstaffinvitations())
  return res
}

export const exportAll = async (reqData: aggr.UserMgmtStaffExportAllRq) => {
  const res = await handleApiStatus<any>(() => userMgmtStaffApi.staffExportall(reqData))
  return res
}

export const exportSelected = async (reqData: aggr.UserMgmtStaffExportSelectedRq) => {
  const res = await handleApiStatus<any>(() => userMgmtStaffApi.staffExportselected(reqData))
  return res
}
